<template>
    <textarea class="xes-ckEdtior-textarea" ref="editor" :id="this.id"></textarea>
</template>

<script>
export default {
    data() {
        return {
            id: 'editor' + this.randomString(),
            script: null,
            timer: null
        }
    },
    props: {
        url: {
            type: String,
            require: true
        },
        value: {
            type: String,
            default: ''
        },
        width: {
            type: [String, Number],
            default: 800
        },
        height: {
            type: [String, Number],
            default: 200
        },
        latex: {
            type: Boolean,
            default: false
        },
        params: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    methods: {
        setEditor() {
            this.$nextTick(() => {
                let _this = this
                CKEDITOR.replace(this.id, {
                    height: this.height,
                    width: this.width,
                    toolbar: 'Full',
                    forcePasteAsPlainText: true,
                    pasteFromWordRemoveFontStyles: false,
                    pasteFromWordRemoveStyles: false,
                    allowedContent: true,
                    fileFlag: 'resource', // file对象对应的字段名 ！！！
                    needFileName: true, // 是否需要文件名作为参数中的值
                    extraPlugins: this.extraPlugins,
                    removeDialogTabs: 'image:advanced;image:Link;',
                    easyimage_toolbar: ['EasyImageFull', 'EasyImageSide', 'EasyImageAlignLeft', 'EasyImageAlignCenter'],
                    removeButtons:
                        'CopyFormatting,BGColor,Subscript,Superscript,HorizontalRule,Smiley,PageBreak,SpecialChar,Iframe,Styles,Format,Strike,Flash,Table,Image',
                    toolbarGroups: [
                        {
                            name: 'styles',
                            groups: ['font', 'fontsize']
                        },
                        {
                            name: 'basicstyles',
                            groups: ['bold', 'italic', 'cleanup']
                        },
                        {
                            name: 'colors',
                            groups: ['textcolor']
                        },
                        {
                            name: 'insert',
                            groups: ['mathFormula']
                        }
                    ],
                    originalUnder: true
                })
                CKEDITOR.instances[this.id].once('instanceReady', el => {
                    this.setData()
                    this.$emit('ckEditorReady')
                    this.timer = setInterval(() => {
                        this.setContent()
                    }, 100)
                    CKEDITOR.file_upload = {
                        url: this.url,
                        fileFlag: 'resource', // file对象对应的字段名 ！！！
                        otherParams: [...this.otherParams],
                        callback() {
                            // _this.setContent()
                        },
                        responseData: 'data'
                    }
                })
                CKEDITOR.instances[this.id].on('change', () => {
                    this.setContent()
                })
            })
        },
        setContent() {
            setTimeout(() => {
                if (!CKEDITOR.instances[this.id]) return
                let content = CKEDITOR.instances[this.id].getData()
                this.$emit('input', content)
            })
        },
        setData() {
            if (this.latex) {
                CKEDITOR.instances[this.id].insertData(this.value)
            } else {
                CKEDITOR.instances[this.id].setData(this.value)
            }
        },
        getData() {
            return CKEDITOR.instances[this.id].getData()
        },
        removeEditor() {
            CKEDITOR.remove(CKEDITOR.instances[this.id])
        },
        clearContent() {
            CKEDITOR.instances[this.id].setData('')
            this.setContent()
        },
        randomString(len) {
            len = len || 32
            var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
            var maxPos = $chars.length
            var pwd = ''
            for (let i = 0; i < len; i++) {
                pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
            }
            return pwd
        },
        nativeFn(flag, ...ams) {
            CKEDITOR.instances[this.id][flag](...ams)
        }
    },
    computed: {
        extraPlugins() {
            if (this.latex) {
                return 'easyimage,underline2,mathjax'
            }
            return 'easyimage,underline2'
        },
        otherParams() {
            let data = []
            for (let item in this.params) {
                data.push({ name: item, val: this.params[item] })
            }
            return data
        }
    },
    created() {
        if (typeof CKEDITOR != 'undefined') {
            this.setEditor()
            return
        }
        this.script = document.createElement('script')
        this.script.type = 'text/javascript'
        // this.script.src = './static/ckeditor/ckeditor.js';
        this.script.src = 'http://formula.xesv5.com/CKEditor/ckeditor/ckeditor.js'
        document.body.appendChild(this.script)
        this.script.onload = () => {
            this.setEditor()
        }
    },
    beforeDestroy() {
        this.removeEditor()
        // this.script.parentNode.removeChild(this.script)
        let editor = document.querySelector('.cke_editor_' + this.id)
        editor && editor.parentNode.removeChild(editor)
        clearInterval(this.timer)
    }
}
</script>



// WEBPACK FOOTER //
// packages/question-error/src/ckEdtior.vue